class sectionVideo extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      videoContainer: '[js-video-container]',
    }
  }

  connectedCallback() {
    this.videos = this.querySelectorAll('video');
    this.initControls();
  }

  initControls() {
    const playMobile = this.querySelector('[js-play-pause-button-mobile]');
    const soundMobile = this.querySelector('[js-sound-button-mobile]');
    const playDesktop = this.querySelector('[js-play-pause-button-desktop]');
    const soundDesktop = this.querySelector('[js-sound-button-desktop]');
    const enabledControls = this.dataset.controls;

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024) {
        this.videos[0].load();
        this.videos[0].muted = true;
        if (playMobile) {
          playMobile.setAttribute("aria-playing", false);
        }
        if (soundMobile) {
          soundMobile.setAttribute("aria-mute", true);
        }
      } else {
        this.videos[1].load();
        this.videos[1].muted = true;
        if (playDesktop) {
          playDesktop.setAttribute("aria-playing", false);
        }
        if (soundDesktop) {
          soundDesktop.setAttribute("aria-mute", true);
        }
      }
    });

    if (playMobile) {
      playMobile.addEventListener('click', (evt) => {
        evt.stopImmediatePropagation();
        const currentPlaying = playMobile.getAttribute("aria-playing"); 
        playMobile.setAttribute("aria-playing", currentPlaying === "true" ? "false" : "true");
        if (this.videos[0].paused) {
          this.videos[0].play();
          if (enabledControls) {
            this.videos[0].controls = true;
          }
        } else {
          this.videos[0].pause();
        }
      });
    }

    if (soundMobile) {
      soundMobile.addEventListener('click', (evt) => {
        evt.stopImmediatePropagation();
        const currentMute = soundMobile.getAttribute("aria-mute"); 
        soundMobile.setAttribute("aria-mute", currentMute === "true" ? "false" : "true");
        if (this.videos[0].muted) {
          this.videos[0].muted = false;
        } else {
          this.videos[0].muted = true;
        }
      });
    }

    if (playDesktop) {
      playDesktop.addEventListener('click', (evt) => {
        evt.stopImmediatePropagation();
        const currentPlaying = playDesktop.getAttribute("aria-playing"); 
        playDesktop.setAttribute("aria-playing", currentPlaying === "true" ? "false" : "true");
        if (this.videos[1].paused) {
          this.videos[1].play();
          if (enabledControls) {
            this.videos[1].controls = true;
          }
        } else {
          this.videos[1].pause();
        }
      });
    }

    if (soundDesktop) {
      soundDesktop.addEventListener('click', (evt) => {
        evt.stopImmediatePropagation();
        const currentMute = soundDesktop.getAttribute("aria-mute"); 
        soundDesktop.setAttribute("aria-mute", currentMute === "true" ? "false" : "true");
        if (this.videos[1].muted) {
          this.videos[1].muted = false;
        } else {
          this.videos[1].muted = true;
        }
      });
    }
  }
}

customElements.define('section-video', sectionVideo)